export const locations = {
  list: {
    title: 'Locations',
    loading: 'Loading locations...',
    error: 'Failed to load locations.',
    searchPlaceholder: 'Search by name, address or city…',
    actions: {
      add: 'Add Location',
      /** Visible button text — plain, since the row already shows the name. */
      editLabel: 'Edit',
      /** Accessible name, distinguishing repeated "Edit" buttons for assistive tech. */
      edit: 'Edit {{name}}',
    },
    columns: {
      name: 'Name',
      street: 'Street',
      houseNumber: 'House Number',
      addressDetails: 'Address details',
      postalCode: 'Postal Code',
      city: 'City',
      stateRegion: 'State / Region',
      country: 'Country',
      actions: 'Actions',
    },
    result: {
      singular: 'location',
      plural: 'locations',
    },
    filters: {
      countryHint: 'Filter by the countries your locations are in.',
    },
    empty: {
      title: 'No locations yet',
    },
    noResults: {
      title: 'No locations found',
      description: 'Adjust your search or filters to see results again.',
      reset: 'Reset search and filters',
    },
  },
  dialog: {
    addTitle: 'Add new location',
    editTitle: 'Edit {{name}}',
    loading: 'Loading…',
    loadError: 'Failed to load this location.',
  },
  form: {
    fields: {
      name: 'Name',
      street: 'Street',
      houseNumber: 'House Number',
      addressDetails: 'Address details',
      postalCode: 'Postal Code',
      city: 'City',
      stateRegion: 'State / Region',
      countryCode: 'Country',
    },
    placeholders: {
      name: 'Munich Office',
      street: 'Zielstattstraße',
      houseNumber: '13',
      addressDetails: '2nd floor',
      postalCode: '81379',
      city: 'Munich',
      stateRegion: 'Bavaria',
    },
    validation: {
      required: 'This field is required',
    },
    country: {
      search: 'Search country…',
      noMatch: 'No country found',
    },
    actions: {
      save: 'Save',
      saving: 'Saving…',
      cancel: 'Cancel',
    },
  },
  toast: {
    created: 'Location created',
    updated: 'Changes saved',
    saveFailed: 'Location could not be saved. Please try again.',
  },
};

export type LocationsResources = typeof locations;
